import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=logged out

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser((prev) => (prev && typeof prev === "object" ? prev : r.data)))
      .catch(() => setUser((prev) => (prev && typeof prev === "object" ? prev : false)));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("cd_token", data.token);
    setUser(data);
    return data;
  };

  const ssoLogin = async (token) => {
    const { data } = await api.post("/auth/sso", { token });
    if (data.token) localStorage.setItem("cd_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("cd_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, ssoLogin, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
